import { InsertDriveFile } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import { FieldFactory, Resource } from '@/classes';
import { CustomerBrandFile, customerBrandFilePayloadSchema } from '@/types';

export default function customerBrandFiles() {
  return new Resource<CustomerBrandFile>('Brand Files')
    .withSchema(customerBrandFilePayloadSchema)
    .withFieldsAndColumns([
      FieldFactory.file('file').renderCellUsing((v, r) => (
        <Avatar src={r.image} sx={{ border: '1px #ddd solid' }}>
          <InsertDriveFile />
        </Avatar>
      )),
      FieldFactory.text('name').withLabel('File Name').withColumnSpan(3),
      FieldFactory.select('type', {
        logo: 'Logo',
        font: 'Font',
        other: 'Other',
      }).withColumnSpan(2),
      FieldFactory.list('colors', [FieldFactory.color('')]).with({
        addNewValue: undefined,
      }),
      FieldFactory.number('density')
        .withInputProps({
          step: 1,
          min: 0,
          max: 1000,
        })
        .withHelp(
          'Out of 1000 pixels, how many are filled? Used for estimating embroidery stitch counts.',
        ),
    ]);
}
